/**
 * MHH Experience System — Hero Experience interactions
 * Sticky ATC viewport trigger + chat widget offset
 */
(function () {
  'use strict';

  function initStickyAtc() {
    var sticky = document.querySelector('[data-mhh-exp-sticky-atc]');
    var buyPath = document.getElementById('mhh-exp-buy-path');
    if (!sticky || !buyPath) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var visible = false;

    function setChatOffset() {
      var offset = 0;
      var selectors = [
        '#gorgias-chat-container',
        '#chat-button',
        '.intercom-lightweight-app',
        '#hubspot-messages-iframe-container',
        '[id*="chat-widget"]',
        '[class*="chat-widget"]'
      ];
      selectors.forEach(function (sel) {
        var el = document.querySelector(sel);
        if (el && el.offsetHeight) {
          offset = Math.max(offset, el.offsetHeight);
        }
      });
      if (offset > 0) {
        sticky.classList.add('has-chat-offset');
        sticky.style.setProperty('--mhh-exp-sticky-chat-offset', offset + 'px');
      }
    }

    function showBar() {
      if (visible || window.innerWidth >= 768) return;
      visible = true;
      sticky.classList.add('is-visible');
      if (!reducedMotion) {
        sticky.classList.add('mhh-exp-motion-sticky-enter');
      }
      sticky.setAttribute('aria-hidden', 'false');
    }

    function hideBar() {
      if (!visible) return;
      visible = false;
      sticky.classList.remove('is-visible', 'mhh-exp-motion-sticky-enter');
      sticky.setAttribute('aria-hidden', 'true');
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              hideBar();
            } else {
              showBar();
            }
          });
        },
        { root: null, threshold: 0, rootMargin: '0px 0px -10% 0px' }
      );
      observer.observe(buyPath);
    }

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 768) hideBar();
      setChatOffset();
    }, { passive: true });

    setChatOffset();

    var stickyBtn = sticky.querySelector('[data-mhh-exp-sticky-submit]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        var form = document.querySelector(buyPath.getAttribute('data-form-selector') || '.js-mhh-exp-product-form');
        if (!form) {
          buyPath.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
          return;
        }
        var submit = form.querySelector('[type="submit"][name="add"]');
        if (submit && !submit.disabled) {
          e.preventDefault();
          submit.click();
        } else {
          buyPath.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        }
      });
    }
  }

  function initTrustPolicyToggle() {
    document.querySelectorAll('[data-mhh-exp-policy-toggle]').forEach(function (btn) {
      var panelId = btn.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        panel.hidden = expanded;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initStickyAtc();
      initTrustPolicyToggle();
    });
  } else {
    initStickyAtc();
    initTrustPolicyToggle();
  }
})();
